import { forwardRef } from "react";

interface GoKeycapProps {
  onClick?: (e: React.MouseEvent) => void;
  size?: "large" | "compact";
  className?: string;
}

const GoKeycap = forwardRef<HTMLButtonElement, GoKeycapProps>(
  ({ onClick, size = "large", className = "" }, ref) => {
    const isCompact = size === "compact";

    return (
      <button
        ref={ref}
        type="button"
        onClick={onClick}
        tabIndex={-1}
        className={`comic-play-btn relative overflow-hidden select-none cursor-pointer
          font-mono font-extrabold
          bg-primary text-primary-foreground
          border-[hsl(24,80%,35%)] rounded-md
          hover:rotate-[-0.5deg]
          active:scale-95
          transition-all duration-150 transform
          ${isCompact
            ? "text-base px-2.5 py-1 border-[2px] shadow-[2px_2px_0px_0px_hsl(var(--foreground))] hover:shadow-[1px_1px_0px_0px_hsl(var(--foreground))] hover:translate-x-[1px] hover:translate-y-[1px] hover:scale-[1.02]"
            : "text-xl px-4 py-2 border-[3px] shadow-[4px_4px_0px_0px_hsl(var(--foreground))] hover:shadow-[2px_2px_0px_0px_hsl(var(--foreground))] hover:translate-x-[2px] hover:translate-y-[2px] hover:scale-[1.03]"
          }
          ${className}`}
      >
        <span className="relative z-10">GO</span>
        <span className={`relative z-10 opacity-80 font-normal ml-1 ${isCompact ? "text-base" : "text-xl"}`}>↵</span>
      </button>
    );
  }
);

GoKeycap.displayName = "GoKeycap";

export default GoKeycap;
